<!-- version 1.0.0 -->
<!-- 2017-9-17 -->
<template>
  <div>
    <div class="upload-tip" :class="{'small':size==='small','tine':size==='tine'}" v-if="tip">
      <el-alert :title="tip" type="info" :closable="false"></el-alert>
    </div>
    <!-- 单图 -->
    <div class="mc-upload-wrap" v-if="!mult">
      <div class="upload-field" :class="{'has-upload':img,'small':size==='small','tine':size==='tine'}" v-imageupload="img" v-on:upload-change="singleImgUplad">
        <div class="tip">请上传图片</div>
        <div class="pic-wrap">
          <img :src="img">
        </div>
        <div class="upload-cover">点击图片以修改</div>
      </div>
    </div>
    <!-- 多图 -->
    <div class="mc-upload-wrap mult-wrap" v-else>
      <div class="upload-field tine ftp" :class="{'has-upload':item}" v-for="(item, i) in multImgList" :key="i" v-imageupload="item" v-on:upload-change="multImgUplad($event, i)">
        <div class="tip">请上传图片</div>
        <div class="pic-wrap">
          <img :src="item">
        </div>
        <div class="upload-cover">点击图片以修改</div>
        <div class="del-btn ic-del" @click.stop="delImg(i)" v-if="i !== multImgList.length - 1"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
import tools from '@/components/common/tools'

export default {
  name: 'imgUpload',
  props: {
    // prompt文字
    tip: {
      type: String,
      default: ''
    },
    // 是否多图
    mult: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'normal'
    },
    // 多图模式下,列个数
    colNbr: {
      type: Number,
      default: 1
    },
    value: {
      type: String,
      default: ''
    }
  },
  created() {
    this.setValue(this.value)
  },
  data() {
    return {
      img: '',
      imgList: ''
    }
  },
  watch: {
    // 值变化
    value(newVal) {
      this.setValue(newVal)
    }
  },
  computed: {
    // 多图列表
    multImgList() {
      if (this.imgList) {
        let data = tools.getModel(this.imgList)
        data.push('')
        return data
      } else {
        return ['']
      }
    }
  },
  methods: {
    setValue(val) {
      if (this.mult) {
        // 多图
        if (val) {
          this.imgList = val.split(',')
        } else {
          this.imgList = []
        }
      } else {
        // 单图
        this.img = val
      }
    },
    // 更新值
    updateValue() {
      if (this.mult) {
        // 多图
        this.$emit('input', this.imgList.join(','))
      } else {
        // 单图
        this.$emit('input', this.img)
      }
    },
    // 单图片上传成功
    singleImgUplad(url) {
      this.$emit('input', url)
    },
    // 多图片上传成功
    multImgUplad(url, idx) {
      this.imgList[idx] = url
      this.$emit('input', this.imgList.join(','))
    },
    // 删除多图项
    delImg(idx) {
      this.$confirm('是否确认删除?', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(() => {
        this.imgList.splice(idx, 1)
        this.$emit('input', this.imgList.join(','))
      })
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/lib-config";

.upload-tip {
  width: 400px;
  margin-bottom: 10px;
  line-height: 20px;
  &.small {
    width: 200px;
    .el-alert {
      padding: 5px 7px;
    }
  }
}

.isout-switch-wrap {
  line-height: 36px;
  .label {
    margin-right: 5px;
  }
}

.video-upload-warp {
  width: 410px;
}
</style>



// WEBPACK FOOTER //
// img-upload.vue?50909648